import { AddAccountApiParameterExt, addAccountExt as addAccountApiExt } from "@DSG/Services/AccountServiceExt";
import { AccountModelExt } from "@DSG/Type/ApiModelsExt";
import { addToChainAfter, ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { stopWatchingForOtherTabSessionChange, watchForOtherTabSessionChange } from "@insite/client-framework/Services/SessionService";
// import {AddAccount,PopulateApiParameter} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";

// this will enable HMR for custom handlers
// if (module.hot) {
//     module.hot.accept();
//     const originalChain = chain.slice();
//     module.hot.dispose(data => {
//         chain.length = 0;
//         originalChain.forEach(o => chain.push(o));
//     });
// }

export interface AddAccountParameter {
    userName: string;
    email: string;
    //password: string;
    isSubscribed: boolean;
    onSuccess?: () => void;
    onError?: (error: string) => void;
    accountNumber: string;
    emailAddress: string;
    confirmEmailAddress: string;
    branchId: string;
    stateValue:string;
    jobTitle: string;
    segmentsFields: any;
    typeOfWorkFields: any;
    phoneNumber: string;
    firstName:string;
    lastName:string;
    company:string;
    smsOptIn: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<
    AddAccountParameter,
    AddAccountApiParameterExt,
    ServiceResult<AccountModelExt>
>;
export const AddAccountExt: HandlerType = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await addAccountApiExt(props.apiParameter);
    watchForOtherTabSessionChange();
};
// addToChainAfter(chain, AddAccount, AddAccountExt);


export const PopulateApiParameterExt: HandlerType = props => {
    props.apiParameter = {
        account: {
            ...props.parameter,
            jobTitle: props.parameter.jobTitle,
            accountNumber: props.parameter.accountNumber,
            branchId: props.parameter.branchId,
            segments: props.parameter.segmentsFields,
            typeOfWork: props.parameter.typeOfWorkFields,
            selectedState: props.parameter.stateValue,
            smsOptIn: props.parameter.smsOptIn
        } as unknown as AccountModelExt,
    };
};
// addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterExt);

export const chain = [
    PopulateApiParameterExt,
    AddAccountExt,
];

const addAccountExt = createHandlerChainRunner(chain, "AddAccountExt");
export default addAccountExt;